import { INN_MASK, PHONE_MASK, PHONE_PLACEHOLDER } from '@/consts';
import { useNewDataFormCargoPickUpStore } from '@/stores/newFormCargoPickUp';

import { FIOAutocomplete, InnAutocomplete, OrganizationAutocomplete } from '../../../Components';

import { ConsigneeInfoDeliveryForm } from './forms';

import { useFetchDeliveryTimeIntervals } from '@/newCargoPickUpPage/hooks/useFetchDeliveryTimeIntervals';
import { useFetchSuitableOffices } from '@/newCargoPickUpPage/hooks/useFetchSuitableOffices';
import { useCitiesRestrictions } from '@/stores/citiesRestrictions';
import { limitInput } from '@/utils/handleChangeForm';
import { computed, inject, ref, watch, watchEffect } from 'vue';

export default {
  props: {
    isCargoPickup: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    InnAutocomplete,
    OrganizationAutocomplete,
    ConsigneeInfoDeliveryForm,
    FIOAutocomplete,
  },

  setup(props) {
    const dataForm = useNewDataFormCargoPickUpStore();

    const isOpeModalCargoDelivery = ref(false);

    const officesToSelect = ref(['Сухово, 14', 'Победа, 34']);

    const onClickAddressDelivery = () => {
      isOpeModalCargoDelivery.value = true;
    };

    const handleChangeTypeOfPerson = inject('handleChangeTypeOfPerson');

    const ruleFormRef = inject('ruleFormRef');

    const consigneeDeliveryFullAddress = computed(() => (dataForm.consignee.addressCargoDelivery.value || '') + ' ' + dataForm.consignee.detailsDelivery);

    const citiesRestrictions = useCitiesRestrictions();

    const resetCargoInformation = inject('resetCargoInformation');

    const citiesArr = inject('citiesArr', []);

    const cities = inject('citiesDelivery');

    const handleConsigneeDelivery = () => {
      dataForm.consignee.addressCargoDelivery = '';
      dataForm.consignee.detailsDelivery = '';

      dataForm.consignee.cargoTimeDelivery = '';

      dataForm.consignee.whoPaysCargoDelivery = '';
      dataForm.consignee.typeOfPaymentCargoDelivery = '';

      if (dataForm.consignee.consigneeDeliveryType === 'Забрать на складе') {
        if (dataForm.fetchedSuitableOffices.delivery.length === 1) {
          dataForm.consignee.addressCargoDelivery = dataForm.fetchedSuitableOffices.delivery[0];
        }
      }
    };

    const disabledDeliveryType = ref(false);

    watchEffect(() => {
      const consigneeCredentials = Boolean(dataForm.consignee.fioConsignee || dataForm.consignee.name || dataForm.consignee.innConsignee);
      const cityTo = Boolean(dataForm.consignee.cityTo);
      const selected = dataForm.consignee.consigneeDeliveryType;
      const validData = cityTo;
      if (validData && !selected) {
        dataForm.consignee.consigneeDeliveryType = 'Доставка до адреса';
      }

      disabledDeliveryType.value = !(validData || selected);
    });

    const options = [
      {
        value: 'Стандарт',
        label: 'Стандарт',
      },
      {
        value: 'Цилиндры',
        label: 'Цилиндры',
      },
      {
        value: 'Шины',
        label: 'Шины',
      },
    ];

    const cityToRestrictions = inject('cityToRestrictions');

    const resetAddress = () => {
      dataForm.consignee.addressCargoDelivery = '';
      dataForm.consignee.detailsDelivery = '';
      dataForm.consignee.cargoTimeDelivery = '';
      dataForm.consignee.whoPaysCargoDelivery = '';
      dataForm.consignee.typeOfPaymentCargoDelivery = '';

      dataForm.consignee.consigneeDeliveryType = 'Доставка до адреса';
    };

    async function handlerCityTo(city) {
      Promise.allSettled([useFetchSuitableOffices('issuanceOfCargo'), useFetchDeliveryTimeIntervals(city.id)]).then(() => {
        resetAddress();
      });

      // #TODO
      // await citiesRestrictions.handleCityRestrictions('cityTo', city);

      // resetCargoInformation();
    }

    watch(
      () => dataForm.fetchedSuitableOffices.delivery,
      (newVal) => {
        const currentSelection = dataForm.consignee.addressCargoDelivery;
        if (currentSelection && dataForm.consignee.consigneeDeliveryType === 'Забрать на складе') {
          if (newVal.length === 0) {
            resetAddress();
          } else {
            if (newVal.findIndex((el) => el.id === currentSelection.id) === -1) {
              dataForm.sender.addressCargoPickup = '';
            }
          }
        }
      }
    );

    return {
      dataForm,
      cities,
      isOpeModalCargoDelivery,
      citiesArr,
      handlerCityTo,
      consigneeDeliveryFullAddress,
      options,
      PHONE_MASK,
      INN_MASK,
      PHONE_PLACEHOLDER,
      officesToSelect,
      limitInput,

      disableIdenticalCity: function (value) {
        if (value && value.id === dataForm.sender.cityFrom?.id) {
          return true;
        }

        return false;
      },
      handleConsigneeDelivery,
      onClickAddressDelivery,
      handleChangeTypeOfPerson,
      disabledDeliveryType,
      ruleFormRef,

      checkPhone: function () {
        if (dataForm.consignee.phoneConsignee === dataForm.sender.phoneSender) {
          dataForm.consignee.emailConsignee = dataForm.sender.emailSender;
          if (dataForm.consignee.consigneeType) {
            dataForm.consignee.innConsignee = dataForm.sender.innSender;
            dataForm.consignee.name = dataForm.sender.name;
          } else {
            dataForm.consignee.fioConsignee = dataForm.sender.fioSender;
          }
        }
      },
    };
  },
};
